import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const blockApi = createApi({
  reducerPath: "blockApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    createBlock: builder.mutation({
      query: (newBlock) => ({
        url: "block/",
        method: "POST",
        body: newBlock,
      }),
    }),
    deleteBlock: builder.mutation({
      query: (id) => ({
        url: `block/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useCreateBlockMutation,
  useDeleteBlockMutation,
} = blockApi;